import React from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
} from '@mui/material';

const data = [
    { rating: 'O', classification: 'OUTSTANDING', definition: '96-100' },
    { rating: 'MAE', classification: 'MEETS ALL EXPECTATIONS', definition: '80-95' },
    { rating: 'MME', classification: 'MEETS MOST EXPECTATIONS', definition: '61-79' },
    { rating: 'BE', classification: 'BELOW EXPECTATION', definition: '<=60' },
];

const RatingTable = () => {
    return (
        <TableContainer component={Paper} sx={{
            maxWidth: 600,
            // margin: 'auto',
            mt: 4
        }}>
            <Table>
                <TableHead>
                    <TableRow sx={{ backgroundColor: 'var(--main-color)' }}>
                        <TableCell
                            sx={{
                                // "& .MuiTableCell-root": {
                                //     padding:"20px"

                                // }
                                p: "0px  10px"
                            }}
                        >
                            <Typography variant="subtitle2" fontWeight="bold" color="white">
                                RATING
                            </Typography>
                        </TableCell>
                        <TableCell
                            sx={{
                                // "& .MuiTableCell-root": {
                                //     padding:"20px"

                                // }
                                p: "0px  10px"
                            }}
                        >
                            <Typography variant="subtitle2" fontWeight="bold" color="white">
                                CLASSIFICATIONS
                            </Typography>
                        </TableCell>
                        <TableCell
                            sx={{
                                // "& .MuiTableCell-root": {
                                //     padding:"20px"

                                // }
                                p: "5px  10px"
                                
                            }}>
                            <Typography variant="subtitle2" fontWeight="bold" color="white">
                                DEFINITION
                            </Typography>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((row, index) => (
                        <TableRow key={index}>
                            <TableCell
                                sx={{
                                    // "& .MuiTableCell-root": {
                                    //     padding:"20px"

                                    // }
                                    p: "5px  10px"
                                }}><Typography variant='body1' style={{ color: "black", p: 0 }}>{row.rating}</Typography></TableCell>
                            <TableCell><Typography variant='body1' style={{ color: "black" }}>{row.classification}</Typography></TableCell>
                            <TableCell><Typography variant='body1' style={{ color: "black" }}>{row.definition}</Typography></TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default RatingTable;
